import { IStateSlice, AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { WebsitePageNamesEnum } from '../enums';

export class LoyaltyWebsiteState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public currentPage: WebsitePageNamesEnum | null;
  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.currentPage = null;
  }
}
